/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
class GeoCastingService extends __BaseService {
  static readonly GeoCastingGetElevationProfileForCameraPath = '/api/GeoCasting/GetElevationProfileForCamera';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `GeoCastingService.GeoCastingGetElevationProfileForCameraParams` containing the following parameters:
   *
   * - `siteId`:
   *
   * - `customerId`:
   *
   * - `bearing`:
   */
  GeoCastingGetElevationProfileForCameraResponse(params: GeoCastingService.GeoCastingGetElevationProfileForCameraParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.siteId != null) __params = __params.set('siteId', params.siteId.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    if (params.bearing != null) __params = __params.set('bearing', params.bearing.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/GeoCasting/GetElevationProfileForCamera`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `GeoCastingService.GeoCastingGetElevationProfileForCameraParams` containing the following parameters:
   *
   * - `siteId`:
   *
   * - `customerId`:
   *
   * - `bearing`:
   */
  GeoCastingGetElevationProfileForCamera(params: GeoCastingService.GeoCastingGetElevationProfileForCameraParams): __Observable<Blob> {
    return this.GeoCastingGetElevationProfileForCameraResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module GeoCastingService {

  /**
   * Parameters for GeoCastingGetElevationProfileForCamera
   */
  export interface GeoCastingGetElevationProfileForCameraParams {
    siteId?: number;
    customerId?: number;
    bearing?: number;
  }
}

export { GeoCastingService }
